import React, { useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import {
  FileInfo,
  CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1Document,
  CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesDocument,
  FileInfoInput
} from '../../../../../../generated';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
import { VerificationComponentPacketDocumentPicker } from './verification-component-packet-document-picker';
import { message } from 'antd';

interface VerificationComponentPacketDocumentPickerContainerProps {
  onMergePdfComplete: () => Promise<void>;
  verificationFileNames: Map<string, string>;
  verificationFileName: string;
  caseId: string;
  onCancel: () => void;
}

export const VerificationComponentPacketDocumentPickerContainer: React.FC<VerificationComponentPacketDocumentPickerContainerProps> = (props) => {
  const [isProcessingMergingPdfs, setIsProcessingMergingPdfs] = useState(false);

  const [mergeAndUploadPdfFiles] = useMutation(
    CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesDocument
  );

  const [getFileData, { data: fileData }] = useLazyQuery(CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1Document, {
    fetchPolicy: 'network-only'
  });

  const fetchFileData = () => {
    getFileData({
      variables: {
        credentialVerificationCaseV1Id: props.caseId
      }
    });
  };

  useEffect(() => {
    fetchFileData();
  }, []);

  console.log('verification files data: ', fileData);

  const blobUrls: FileInfo[] = [
    {
      name: '',
      url: ''
    },
    { name: '', url: '' },
    { name: '', url: '' }
  ];

  fileData?.credentialVerificationCaseV1?.files?.filter((file: FileInfo | null) => {
    const fileName = file?.name?.split('/').pop();
    if (fileName === props.verificationFileNames.get('credential')) {
      blobUrls[0] = {
        url: file?.url ?? '',
        name: file?.name ?? '',
        type: file?.type ?? ''
      };
    } else if (fileName === props.verificationFileNames.get('translation')) {
      blobUrls[1] = {
        url: file?.url ?? '',
        name: file?.name ?? '',
        type: file?.type ?? ''
      };
    } else if (fileName === props.verificationFileNames.get('verificationPacketResponse')) {
      blobUrls[2] = {
        url: file?.url ?? '',
        name: file?.name ?? '',
        type: file?.type ?? ''
      };
    }
    return props.verificationFileNames.get('credential') || props.verificationFileNames.get('translation') || props.verificationFileNames.get('verificationPacketResponse');
  });

  const handlePdfMerge = async (blobPaths: FileInfoInput[]) => {
    const blobPathsInput = blobPaths.filter((blobpath) => blobpath.fileName !== "");
    setIsProcessingMergingPdfs(true);
    mergeAndUploadPdfFiles({
      variables: {
        input: {
          blobPaths: blobPathsInput,
          caseId: props.caseId,
          fileName: props.verificationFileName
        }
      }
    }).then(async (res) => {
      if (res.data?.credentialVerificationCaseV1MergePdfFiles?.status.success) {
        await props.onMergePdfComplete();
      } else {
        message.error('Error merging PDFs');
      }
      setIsProcessingMergingPdfs(false);
    });
  };
  return (
    <ComponentQueryLoader
      loading={!fileData}
      hasData={fileData}
      hasDataComponent={
        <VerificationComponentPacketDocumentPicker
          onCancel={props.onCancel}
          handlePdfMerge={handlePdfMerge}
          blobUrls={blobUrls}
          verificationFileNames={props.verificationFileNames}
          isProcessingMergingPdfs={isProcessingMergingPdfs}
        />
      }
    />
  );
};
